import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';
import { DrawerLetterBody } from '../../drawer/DrawerLetterBody';
import { LetterFormData } from '../hooks/useLetterForm';
import { LetterTypes, Sources } from '../types';

export interface OtafLetterContentProps {
  source: Sources;
  formData: LetterFormData;
  carrier: Carriers;
  riders: string[];
  isJuvenile?: boolean;
}

const OtafLetterContent = ({
  source,
  formData,
  carrier,
  riders,
  isJuvenile = false,
}: OtafLetterContentProps) => (
  <DrawerLetterBody
    letterType={LetterTypes.otaf}
    pricingMode="higher"
    isJuvenile={isJuvenile}
    carrier={carrier}
    carrierDisplayName={
      CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName() ?? ''
    }
    riders={riders}
    selectedRiders={riders}
    selectedSources={[source]}
    fieldValues={formData as Record<string, string>}
    hasFcra={false}
  />
);

export default OtafLetterContent;
